@import '../../../../constants/spacing.module.less';

.nickname-container {
  display: flex;
  align-items: center;
  gap: @space-12;
  margin-bottom: @space-8;
  min-height: 32px;
}

.nickname-text {
  font-size: 16px;
  font-weight: 500;
  color: var(--grey-900);
}

.edit-button {
  padding: 0;
  min-width: auto;

  &:hover {
    background: transparent;
  }
}

.pencil-icon {
  color: var(--primary--icon--fill-color--2);
  font-size: 14px;
  cursor: pointer;
  width: 16px;
  height: 16px;

  &:hover {
    color: var(--primary--icon--fill-color--4);
  }
}

.nickname-input {
  width: 200px;
}

.action-button {
  padding: @space-4 @space-8;
}

.save-icon {
  color: var(--success--icon--fill-color--1);
  height: 16px;
}

.cancel-icon {
  color: var(--error--icon--fill-color--1);
  height: 16px;
}

.error-message {
  color: var(--error--message--fill-color--1);
  font-size: 12px;
  margin-top: @space-4;
}
